<div class="header flex justify-between items-center py-[0.8rem] px-[0.5rem]">
  <h6 class="!mb-0">{{ data.title }}</h6>
  <img
    src="assets/icons/cross-icon.svg"
    alt="cross icon"
    class="crossicon cursor-pointer"
    (click)="cancel()"
  />
</div>

<div class="content">
  <p class="text-lg">{{ data.label }}</p>
</div>

<div class="footer flex justify-end">
  <button
    class="bg-[#F1F3F5] text-[#E76B3F] px-[1.5rem] py-2 rounded mr-4 border-[1px] border-[#E76B3F]"
    (click)="cancel()"
  >
    {{ data.cancelText }}
  </button>
  <button
    class="bg-[#E76B3F] text-[#F1F3F5] px-[1.5rem] py-2 rounded"
    (click)="confirm()"
  >
    {{ data.confirmText }}
  </button>
</div>
